module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-19ec556b5557c2c81fc28386bfb12a9d.png";